export const PerfiosConstants = {

    POST_NETBANKING_REQUEST: 'POST_NETBANKING_REQUEST',
    POST_NETBANKING_SUCCESS: 'POST_NETBANKING_SUCCESS',
    POST_NETBANKING_FAILURE: 'POST_NETBANKING_FAILURE',

    POST_UPLOAD_STATEMENT_REQUEST: 'POST_UPLOAD_STATEMENT_REQUEST',
    POST_UPLOAD_STATEMENT_SUCCESS: 'POST_UPLOAD_STATEMENT_SUCCESS',
    POST_UPLOAD_STATEMENT_FAILURE: 'POST_UPLOAD_STATEMENT_FAILURE'
};